module.exports = __webpack_public_path__ + "img/home7.28a69c70.png";